import './Form.css'

export default function Form({ className, onSubmit, title, children }) {
	return (
		<form className={`form ${className ?? ''}`} onSubmit={onSubmit}>
			{title &&
				<h1 className="form_title">
					{title}
				</h1>
			}
			{children}
		</form>
	)
}
